// extracted by mini-css-extract-plugin
export default {"light":"loader_light__m5deF","loadingFlash":"loader_loadingFlash__mNgg4","loadingContainer":"loader_loadingContainer__ehSjX"};